import React from 'react';

interface BottomSheetModalProviderProps {
  children: React.ReactNode;
}

/**
 * Web implementation of BottomSheetModalProvider
 * No provider needed for react-native-raw-bottom-sheet
 */
const BottomSheetModalProvider: React.FC<BottomSheetModalProviderProps> = ({ children }) => {
  return <>{children}</>;
};

export default BottomSheetModalProvider;

